module.exports = __webpack_public_path__ + "static/media/confetti-2.b42539b1.gif";